/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BookingStage,
  PaginatedStageList,
  PatchedStage,
  Stage,
} from '../models/index';
import {
    BookingStageFromJSON,
    BookingStageToJSON,
    PaginatedStageListFromJSON,
    PaginatedStageListToJSON,
    PatchedStageFromJSON,
    PatchedStageToJSON,
    StageFromJSON,
    StageToJSON,
} from '../models/index';

export interface StagesBookingDirectoryRequest {
    ordering?: string;
    search?: string;
}

export interface StagesCreateRequest {
    stage: Omit<Stage, 'id'|'venueName'|'teamName'|'createdAt'|'updatedAt'>;
}

export interface StagesDestroyRequest {
    id: string;
}

export interface StagesListRequest {
    ordering?: string;
    page?: number;
    search?: string;
}

export interface StagesPartialUpdateRequest {
    id: string;
    patchedStage?: Omit<PatchedStage, 'id'|'venueName'|'teamName'|'createdAt'|'updatedAt'>;
}

export interface StagesRetrieveRequest {
    id: string;
}

export interface StagesUpdateRequest {
    id: string;
    stage: Omit<Stage, 'id'|'venueName'|'teamName'|'createdAt'|'updatedAt'>;
}

/**
 * 
 */
export class StagesApi extends runtime.BaseAPI {

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesBookingDirectoryRaw(requestParameters: StagesBookingDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BookingStage>>> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/booking-directory/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingStageFromJSON));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesBookingDirectory(requestParameters: StagesBookingDirectoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BookingStage>> {
        const response = await this.stagesBookingDirectoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get stages grouped by capacity tiers.
     */
    async stagesByCapacityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/by_capacity/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * Get stages grouped by capacity tiers.
     */
    async stagesByCapacity(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesByCapacityRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get stages grouped by venue.
     */
    async stagesByVenueRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/by_venue/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * Get stages grouped by venue.
     */
    async stagesByVenue(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesByVenueRaw(initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesCreateRaw(requestParameters: StagesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        if (requestParameters['stage'] == null) {
            throw new runtime.RequiredError(
                'stage',
                'Required parameter "stage" was null or undefined when calling stagesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StageToJSON(requestParameters['stage']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesCreate(requestParameters: StagesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesDestroyRaw(requestParameters: StagesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stagesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesDestroy(requestParameters: StagesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.stagesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesListRaw(requestParameters: StagesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedStageList>> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedStageListFromJSON(jsonValue));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesList(requestParameters: StagesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedStageList> {
        const response = await this.stagesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesPartialUpdateRaw(requestParameters: StagesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stagesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedStageToJSON(requestParameters['patchedStage']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesPartialUpdate(requestParameters: StagesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesRetrieveRaw(requestParameters: StagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stagesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesRetrieve(requestParameters: StagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesUpdateRaw(requestParameters: StagesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling stagesUpdate().'
            );
        }

        if (requestParameters['stage'] == null) {
            throw new runtime.RequiredError(
                'stage',
                'Required parameter "stage" was null or undefined when calling stagesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/stages/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StageToJSON(requestParameters['stage']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StageFromJSON(jsonValue));
    }

    /**
     * ViewSet for Stage CRUD operations. Automatically filters stages by venues owned by user\'s teams.
     */
    async stagesUpdate(requestParameters: StagesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stage> {
        const response = await this.stagesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
